import environment from "../../../common/environment";
import { getResponseData } from "../../../common/utils/api-utils";
import { getAuthenticationHeaders, getDefaultHeaders } from "../../../common/utils/auth-utils";


export async function getFetchWishlistsApiCallMagento(wishListsApiURL: string, authenticated: boolean = true) {
  return await getResponseData(
    new Request(environment().magentoUrl + wishListsApiURL, {
      method: 'GET',
      credentials: 'include',
      headers: authenticated ? getAuthenticationHeaders() : getDefaultHeaders(),
  }));
}